import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { theme } from '../design/theme';

export const SuperAdminLayout: React.FC = () => {
  const menuItems = [
    { label: 'Platform Analytics', path: '/super/dashboard', icon: '📊' },
    { label: 'Companies', path: '/super/companies', icon: '🏢' },
    { label: 'Admins & Companies', path: '/super/admins', icon: '👥' },
    { label: 'Payment History', path: '/super/payments', icon: '📜' },
    { label: 'Global Margin Heatmap', path: '/super/margin', icon: '🗺️' },
    { label: 'Risk Heatmap', path: '/super/risk', icon: '⚠️' },
    { label: 'AI Orchestration', path: '/super/ai-orchestration', icon: '🤖' },
    { label: 'Profile', path: '/super/profile', icon: '👤' },
  ];

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: theme.colors.background.muted }}>
      <Sidebar items={menuItems} title="Exibrain Admin" />
      <main style={{ 
        flex: 1, 
        paddingLeft: 'var(--sidebar-width, 280px)', // We'll need to handle this globally or with a hook
        transition: 'padding-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        width: '100%'
      }}>
        <div style={{ 
          maxWidth: theme.layout.maxWidth, 
          margin: '0 auto',
          padding: theme.spacing.xl,
          width: '100%'
        }}>
          <Outlet />
        </div>
      </main>
    </div>
  );
};
